export class AdditionalRequirementsModel {
    correctiveLens: boolean;
    stateWaiver: boolean;
    safteyRegulations: boolean;
    providedMec: boolean;
    incompleteMec: boolean;
    expiredMec: boolean;
    additionalInfo: boolean;
    additionalInfoText: string;
    incidentTypeId: number;
}
